import {
  useDisclosure,
  useColorModeValue,
  Button,
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import Form from "@rjsf/core";
import { RJSFSchema } from "@rjsf/utils";
import { useRef, useState, useEffect } from "react";
import {
  FactoryDigitalmallBackofficeV1Stock,
  useStockServiceListStocksQuery,
} from "../../app/genericApiGenerated";
import CreateStockForm from "../../gen/Stocks/CreateStockForm";
import { StocksTable } from "./stocks-table";

const ModalForm = ({
  isOpen,
  onClose,
  initialRef,
  finalRef,
  createStocksFormRef,
}: any) => (
  <Modal
    initialFocusRef={initialRef}
    finalFocusRef={finalRef}
    isOpen={isOpen}
    onClose={onClose}
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>Create new Stocks</ModalHeader>
      <ModalCloseButton />
      <ModalBody pb={6}>
        <CreateStockForm
          onFormSubmitted={() => {
            onClose;
            // setIsCreated(!isCreated);
          }}
          ref={createStocksFormRef}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          colorScheme="blue"
          mr={3}
          onClick={() => {
            createStocksFormRef.current?.submit();
          }}
        >
          Add
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
export function Stocks() {
  const {
    data: queryData,
    isSuccess: success,
    isFetching: fetch,
    isError: error,
  } = useStockServiceListStocksQuery({});
  console.log(queryData);
  // const createProductFormRef = useRef<Form<any, RJSFSchema, any>>(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = useRef(null);
  const finalRef = useRef(null);
  const createStocksFormRef = useRef<Form<any, RJSFSchema, any>>(null);

  const [stocks, setStocks] = useState<FactoryDigitalmallBackofficeV1Stock[]>(
    []
  );

  useEffect(() => {
    console.log(queryData);
    setStocks(queryData?.stocks as FactoryDigitalmallBackofficeV1Stock[]);
  }, [success, fetch, error]);

  return (
    <div>
      <Box as="section" bg={useColorModeValue("gray.100", "gray.800")} p="4">
        <div>
          <Box width="100%" textAlign="right" marginBottom="4" marginRight="12">
            <Button colorScheme="blue" onClick={onOpen}>
              Add Stock
            </Button>
          </Box>
        </div>
        <ModalForm
          isOpen={isOpen}
          onClose={onClose}
          initialRef={initialRef}
          finalRef={finalRef}
          createStocksFormRef={createStocksFormRef}
        />
        <StocksTable stocks={stocks} />
      </Box>
    </div>
  );
}
